import { Brand } from 'even-ts-static'
import * as React from 'react'
import { connect } from 'react-redux'

import { CommonState } from 'embed/reducers'
import { AD_DISCLOSURE_TITLE, ContactEven } from 'embed/constants'
import { brandSelector } from 'embed/selectors/config'
import { formattedPhoneNumber } from 'embed/utils'

interface Props {
  brand: Brand
}

const UnconnectedLifeInsuranceDisclosure = ({ brand }: Props) => (
  <>
    <p>
      <strong>Additional Information</strong>
    </p>
    <p>
      All information entered will be transferred to LeapLife for the purpose of completing a life insurance quote,
      which is powered by Even Financial Inc.
    </p>
    <p>
      If you are offered a quote by LeapLife, you will have the opportunity to review the final quote made by the
      insurer or agency partner, and to accept the policy quote made directly between you and the insurer or agency
      partner. All quotes and terms are presented without guarantee and are subject to change pursuant to each insurer's
      discretion. Your quote will vary based on individual circumstances, including age, height, weight, health and
      other factors. There is no guarantee you will be approved or qualify for the quotes presented. LeapLife does not
      include all insurance companies or all available insurance quotes that may be available to you.
    </p>
    <p>
      We recommend that you read the insurer's and/or agency partner’s personal terms and conditions, as well as any
      disclosures, in full before proceeding with any policy.
    </p>
    <p>
      Even Financial, Inc. is the technology platform powering financial services online such as LeapLife. Even's API
      enables its partners to connect their users with real-time decisions and personalized offers and rates from
      premium financial services providers. Even Financial offices are located at 50 West 23rd Street, Suite 700, New
      York, NY 10010, Telephone number: {formattedPhoneNumber(ContactEven.Phone)}. This site is directed at, and made
      available to, persons in the continental U.S., Alaska and Hawaii only.
    </p>
  </>
)

const mapStateToProps = (state: CommonState) => ({
  brand: brandSelector(state),
})

export const LifeInsuranceDisclosure = connect(mapStateToProps)(UnconnectedLifeInsuranceDisclosure)

export const LifeInsuranceAdvertiserDisclosure = (
  <React.Fragment>
    <p>
      <strong>{AD_DISCLOSURE_TITLE}</strong>
    </p>
    <p>
      The offers that appear are from companies which LeapLife and its partners receive compensation. This compensation
      may influence the selection, appearance, and order of appearance of the offers listed below. However, this
      compensation also facilitates the provision by LeapLife of certain services to you at no charge. The offers shown
      below do not include all financial services companies or all of their available product and service offerings.
    </p>
  </React.Fragment>
)
